import '.bq{position:relative;}.ssr-plugin'
import '.i6{width:64px;}.ssr-plugin'
import '.i7{height:64px;}.ssr-plugin'
import '.c2{flex-shrink:0;}.ssr-plugin'
import '.z{position:absolute;}.ssr-plugin'
import '.i8{bottom:-4px;}.ssr-plugin'
import '.ch{right:-4px;}.ssr-plugin'
import '.dk{border-radius:50%;}.ssr-plugin'
import '.i9{border:2px solid var(--shades-white);}.ssr-plugin'
import '.a3{overflow:hidden;}.ssr-plugin'
import '.ia{width:32px;}.ssr-plugin'
import '.ib{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bq i6 i7 c2"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="z i8 ch dk i9 a3 ia ib"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
